import apiClient from './apiClient';

const ENDPOINT = '/User';

/**
 * User.API – Postman User klasörüne göre endpoint'ler.
 * Her fonksiyon Postman'deki metod ve endpoint adına sadıktır.
 */
export default {
  /** GET /GetUser – Kendi profil bilgilerini getirir */
  getUser(params = {}) {
    return apiClient.get(`${ENDPOINT}/GetUser`, { params });
  },

  /**
   * GET /GetUserDevice – Kullanıcının en son kullanılan cihazını döner.
   * Not: Dokümana göre query param yok; ancak bazı admin ekranları userId ile çağırabiliyor.
   */
  getUserDevice(params = {}) {
    return apiClient.get(`${ENDPOINT}/GetUserDevice`, { params });
  },

  /**
   * GET /GetUserDeviceForContract – Kullanıcının sözleşme akışı için en son kullanılan cihazını döner.
   * (Backend adı dokümana göre)
   */
  getUserDeviceForContract(params = {}) {
    return apiClient.get(`${ENDPOINT}/GetUserDeviceForContract`, { params });
  },

  /** PATCH /UpdateUser – Kendi profilini günceller */
  updateUser(payload) {
    return apiClient.patch(`${ENDPOINT}/UpdateUser`, payload);
  },

  /** POST /User – Kullanıcı oluşturur (admin paneli) */
  createUser(payload) {
    return apiClient.post(`${ENDPOINT}`, payload);
  },

  /** POST /DeleteUser – Kullanıcı siler (admin paneli) */
  deleteUser(payload) {
    return apiClient.post(`${ENDPOINT}/DeleteUser`, payload);
  },

  /** POST /SendLoginOtp – Giriş için OTP gönderir (AllowAnonymous) */
  sendLoginOtp(payload) {
    return apiClient.post(`${ENDPOINT}/SendLoginOtp`, payload);
  },

  /** POST /SendRegisterOtp – Kayıt için OTP gönderir (AllowAnonymous) */
  sendRegisterOtp(payload) {
    return apiClient.post(`${ENDPOINT}/SendRegisterOtp`, payload);
  },

  /** POST /VerifyOtp – OTP doğrular ve Token üretir (AllowAnonymous) */
  verifyOtp(payload) {
    return apiClient.post(`${ENDPOINT}/VerifyOtp`, payload);
  },

  /**
   * POST /SaveBrokerAuth – MQTT broker auth için token hash kaydı.
   * Doküman: FE her uygulama/tarayıcı açılışında çağırmalıdır.
   * Body yok; Authorization header (JWT) ile çalışır.
   */
  saveBrokerAuth() {
    return apiClient.post(`${ENDPOINT}/SaveBrokerAuth`);
  },
};
